import {Button, Col, Form, Row, Space, Table, Tooltip, Typography} from "antd";
import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import {columnsTableMenu, optionsLieuDung} from "./PrescriptionTable.config";
import "./PrescriptionTable.scss";
import {DataTableMenu} from "./PrescriptionTable.config";
import {
  Medicine,
  UnitMedicine,
  UsageMedicine,
} from "types/models/examination-diagnostic-type";
import {
  medicineStoreService,
  medicalExaminationService,
  examOutService,
} from "api";
import {unitStoreService} from "api";
import {usageStoreService, storeService} from "api";
import {useAppSelector} from "redux/hooks";
import {RootState} from "redux/store";
import TableInputAdd from "./TableInputAdd/TableInputAdd";
import Icons from "assets/icons";
import SaveNewGoiThuoc from "./SaveNewGoiThuoc/SaveNewGoiThuoc";
import {EXAM_BTN_CLICK_TYPE} from "types/enums/examination";
import Notification from "components/common/notification/notification";
import {isEqualArray, isValuable, randomId, toArray} from "helper/common";
import {tabKeys} from "types/enums";
import {ModalCustom} from "components/common";
import PrescriptionHistoryModal from "./PrescriptionHistoryModal/PrescriptionHistoryModal";
import SearchPatientService from "api/searchPatient";

const PrescriptionTable = React.forwardRef((props, ref) => {
  // redux
  const ebcClick = useAppSelector(state => state.examClick);
  //
  const [donThuocCu, setDonThuocCu] = useState<any>();
  const [donThuocLichSu, setDonThuocLichSu] = useState<any>();
  const [dataSource, setDataSource] = useState<any>([{}, {}, {}, {}]);
  const [dataSourceOrigin, setDataSourceOrigin] = useState<any>([
    {},
    {},
    {},
    {},
  ]);

  const [medicines, setMedicines] = useState<Medicine[]>([]);

  const [unitMedicine, setUnitMedicine] = useState<UnitMedicine[]>([]);

  const [usageMedicine, setUsageMedicine] = useState<UsageMedicine[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loaiThuoc, setLoaiThuoc] = useState<any>([]);

  const gTRef = useRef<any>();
  const historyModalRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    handleSave: handleSave,
  }));
  const handleSave = async () => {
    console.log("số 1");

    await onSaveDonThuoc();
  };

  const delGoiThuoc = async record => {
    try {
      let response = await storeService.delGoiThuoc({
        id: record.id,
      });
      fetchListGoiThuoc({page: 1, limit: 20});
    } catch (err) {
      Notification("error", "Lỗi khi xóa gói thuốc");
    }
  };

  const goiThuocColumns = [
    {
      title: "Tên gói",
      dataIndex: "name",
      key: "name",
      align: "left",
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      key: "moTa",
    },
    {
      title: "Ghi chú",
      dataIndex: "note",
      key: "ghiChu",
    },
    {
      title: "",
      dataIndex: "action",
      width: "4%",
      render: (v, r, i) => {
        return (
          <Space>
            <Tooltip title="Kê">
              <Button
                icon={<Icons.edit />}
                ghost
                onClick={() => onKe(r)}
              ></Button>
            </Tooltip>
            <Tooltip title="Xoá">
              <Button
                danger
                ghost
                icon={<Icons.remove />}
                onClick={() => delGoiThuoc(r)}
              ></Button>
            </Tooltip>
          </Space>
        );
      },
    },
  ];
  const onKe = (record: any) => {
    setDonThuoc({
      ...donThuoc,
      thuocs: record.medicines.map(it => ({
        ...it,
        idThuoc: it.id,
        tenThuoc: it.name,
        nongDo: it.hamLuong,
        hoatChat: it.hoatChat,
        soLuong: it.soLuong,
        donVi: it.donViTinh,
        lieuDung: it.lieuDung,
      })),
    });
    setDonThuocPhu({
      ...donThuocPhu,
      thuocs: [],
    });
    setSelectedRowKeys([]);
  };
  const {idPKNT} = useAppSelector((state: RootState) => state.examination);
  const {currentIdPKNT} = useAppSelector(
    (state: RootState) => state.examination
  );
  const fetchLoaiThuoc = async params => {
    try {
      setLoading(true);
      let response = await medicineStoreService.getListLoaiThuoc(params);
      setLoaiThuoc(response.data);
      setSelectedRowKeys([]);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const getMedicine = async () => {
    setLoading(true);
    try {
      const response = await medicineStoreService.layDanhMucThuoc();
      setMedicines(response.data);
    } catch (err) {
      // Notification("error", "Lấy danh mục thuốc thất bại!");
    }
    setLoading(false);
  };
  const [donThuoc, setDonThuoc] = useState<any>(null);
  const [donThuocPhu, setDonThuocPhu] = useState<any>(null);
  const [thuocs, setThuocs] = useState<any>([]);
  const fetchListThuocByParam = async params => {
    try {
      setLoading(true);
      let response = await storeService.getListMedicineByParams(params);
      setThuocs(response);
      setLoading(false);
    } catch (err) {
      setLoading(true);
      // notification.error({message: "Lỗi khi lấy danh sách thuốc!"});
    }
  };
  const fetchDonThuocByIdPKNT = async () => {
    try {
      setLoading(true);
      let response = await medicalExaminationService.getDonThuocByIdPKNT({
        idPhieuKhamNgoaiTru: idPKNT,
      });
      if (JSON.stringify(response) !== "[]") {
        setDonThuoc(response);
      } else {
        setDonThuoc(null);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // notification.error({message: "Lỗi khi lấy thông tin đơn thuốc!"})
    }
  };
  const fetchDonThuocPhuByIdPKNT = async () => {
    try {
      setLoading(true);
      let response = await medicalExaminationService.getDonThuocPhuByIdPKNT({
        idPhieuKhamNgoaiTru: idPKNT,
      });
      if (JSON.stringify(response) !== "[]") {
        setDonThuocPhu(response);
      } else {
        setDonThuocPhu(null);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // notification.error({message: "Lỗi khi lấy thông tin đơn thuốc!"})
    }
  };

  const [goiThuocs, setGoiThuocs] = useState<any>([]);
  const [selectedDonThuocs, setSelectedDonThuocs] = useState<any>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
  const [selectedRowKeysDrugPacket, setSelectedRowKeysDrugPaket] =
    useState<any>([]);

  const fetchListGoiThuoc = async params => {
    try {
      setLoading(true);
      let response = await storeService.getListGoiThuoc(params);
      setGoiThuocs(
        response.map(e => ({
          ...e,
          key: e.id,
        }))
      );
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // notification.error({message: "Lỗi khi lấy danh sách gói thuốc!"});
    }
  };

  const getUnit = async () => {
    setLoading(true);
    try {
      const response = await unitStoreService.getUnit();
      setUnitMedicine(response.data.data);
    } catch {
      Notification("error", "Lấy danh sách đơn vị thuốc thất bại!");
    }
    setLoading(false);
  };

  const getUsage = async () => {
    setLoading(true);
    try {
      const response = await usageStoreService.getUsage();
      setUsageMedicine(response.data.data);
    } catch {
      Notification("error", "Lấy danh sách cách dùng thuốc thất bại!");
    }
    setLoading(false);
  };
  const onSelectRow = (selectedRowKeys, selectedRows, info) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedDonThuocs(selectedRows);
  };
  const onSelectRowDrug = (selectedRowKeys, selectedRows, info) => {
    setSelectedRowKeysDrugPaket(selectedRowKeys);
    // setSelectedDonThuocs(selectedRows);
  };
  const rowSelection = {
    selectedRowKeysDrugPacket,
    onChange: (selectedRowKeysDrugPacket: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeysDrugPaket(selectedRowKeysDrugPacket);
    },
  };
  const removeNullDonThuoc = dt => {
    let res = [];
    dt.map((it, index) => {
      it.tenThuoc && it.tenThuoc !== "" && it.tenThuoc !== undefined
        ? (res = [...res, {...it, thuTu: index}])
        : null;
    });
    return res;
  };
  const onSaveDonThuoc = async () => {
    if (!isValuable(idPKNT)) {
      Notification("warning", "Chưa có thông tin bệnh nhân!");
      return;
    }

    // if (isEqualArray(dataSource, dataSourceOrigin, ["key"])) {
    //   return;
    // }

    try {
      let thuocs = removeNullDonThuoc(dataSource);
      if (donThuoc && donThuocPhu) {
        const data = {
          thuocs: thuocs.filter(it => isValuable(it.idThuoc)),
          trangThai: donThuoc.trangThai,
          idPhieuKhamNgoaiTru: idPKNT,
          id: donThuoc.id,
        };
        const dataPhu = {
          thuocs: thuocs.filter(it => !isValuable(it.idThuoc)),
          trangThai: donThuocPhu.trangThai,
          idPhieuKhamNgoaiTru: idPKNT,
          id: donThuocPhu.id,
        };
        let response;
        let responsePhu;
        if (isValuable(donThuoc.id)) {
          response = await medicalExaminationService.putDonThuoc(data);
          responsePhu = await medicalExaminationService.putDonThuocPhu(dataPhu);
        } else {
          response = await medicalExaminationService.postDonThuoc(data);
          responsePhu = await medicalExaminationService.postDonThuocPhu(
            dataPhu
          );
        }
        setDonThuoc({
          ...response,
        });
        setDonThuocPhu({
          ...responsePhu,
        });
      } else if (donThuoc && !donThuocPhu) {
        const data = {
          thuocs: thuocs.filter(it => isValuable(it.idThuoc)),
          trangThai: donThuoc.trangThai,
          idPhieuKhamNgoaiTru: idPKNT,
          id: donThuoc.id,
        };
        const dataPhu = {
          thuocs: thuocs.filter(it => !isValuable(it.idThuoc)),
          idPhieuKhamNgoaiTru: idPKNT,
        };
        let response;
        if (isValuable(donThuoc.id)) {
          response = await medicalExaminationService.putDonThuoc(data);
        } else {
          response = await medicalExaminationService.postDonThuoc(data);
        }
        let responsePhu = await medicalExaminationService.postDonThuocPhu(
          dataPhu
        );
        setDonThuoc({
          ...response,
        });
        setDonThuocPhu({
          ...responsePhu,
          // thuocs: responsePhu.thuocs.map(it => {
          //   return {
          //     ...it,
          //     nongDo: it.hamLuong,
          //   };
          // }),
        });
      } else if (donThuocPhu && !donThuoc) {
        // const data = {
        //   thuocs: thuocs.filter(it => isValuable(it.idThuoc)),
        //   trangThai: donThuoc.trangThai,
        //   idPhieuKhamNgoaiTru: idPKNT,
        //   id: donThuoc.id,
        // };
        const dataPhu = {
          thuocs: thuocs.filter(it => !isValuable(it.idThuoc)),
          trangThai: donThuocPhu.trangThai,
          idPhieuKhamNgoaiTru: idPKNT,
          id: donThuocPhu.id,
        };
        let response;
        if (isValuable(donThuoc.id)) {
          response = await medicalExaminationService.putDonThuocPhu(dataPhu);
        } else {
          response = await medicalExaminationService.postDonThuocPhu(dataPhu);
        }

        setDonThuocPhu({
          ...response,
          // thuocs: response.thuocs.map(it => {
          //   return {
          //     ...it,
          //     nongDo: it.hamLuong,
          //   };
          // }),
        });
      } else {
        const data = {
          thuocs: thuocs.filter(it => isValuable(it.idThuoc)),
          idPhieuKhamNgoaiTru: idPKNT,
        };
        const dataPhu = {
          thuocs: thuocs.filter(it => !isValuable(it.idThuoc)),
          idPhieuKhamNgoaiTru: idPKNT,
        };
        let response = await medicalExaminationService.postDonThuoc(data);
        let responsePhu = await medicalExaminationService.postDonThuocPhu(
          dataPhu
        );
        setDonThuoc({
          ...response,
          // thuocs: response.thuocs.map(it => {
          //   return {
          //     ...it,
          //     nongDo: it.hamLuong,
          //   };
          // }),
        });
        setDonThuocPhu({
          ...responsePhu,
          // thuocs: responsePhu.thuocs.map(it => {
          //   return {
          //     ...it,
          //     nongDo: it.hamLuong,
          //   };
          // }),
        });
      }
      Notification("success", "Lưu thành công!");
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lưu thông tin đơn thuốc!");
    }
  };

  useEffect(() => {
    getMedicine();
    getUnit();
    getUsage();
    fetchListThuocByParam({isEmpty: false});
    fetchLoaiThuoc({});
    fetchListGoiThuoc({page: 1, limit: 20});
  }, []);
  const getDonThuocCu = async id => {
    try {
      const res = await examOutService.getDonThuocCu(id);
      setDonThuocCu([
        ...res?.donThuocDto?.thuocs,
        ...res?.donThuocPhuDto?.thuocs,
      ]);
    } catch (error) {}
  };
  useEffect(() => {
    const _setDataSource = donThuocCu => {
      const _dataSource = [
        ...dataSource,
        ...toArray(donThuocCu)?.map(e => ({...e, key: randomId()})),
      ];
      if (removeNullDonThuoc(_dataSource)?.length > 0) {
        setDataSource(removeNullDonThuoc(_dataSource));
      } else {
        setDataSource(_dataSource);
      }
    };
    _setDataSource(donThuocCu);
  }, [donThuocCu]);
  useEffect(() => {
    const _setDataSource = donThuocLichSu => {
      const _dataSource = [
        ...dataSource,
        ...toArray(donThuocLichSu)?.map(e => ({...e, key: randomId()})),
      ];
      if (removeNullDonThuoc(_dataSource)?.length > 0) {
        setDataSource(removeNullDonThuoc(_dataSource));
      } else {
        setDataSource(_dataSource);
      }
    };
    _setDataSource(donThuocLichSu);
  }, [donThuocLichSu]);
  useEffect(() => {
    setDonThuocCu([]);
  }, [idPKNT]);
  const selectedDTSave = useMemo(() => {
    let data = [];
    dataSource.map(it => {
      const tmp = selectedDonThuocs.find(dt => dt.key == it.key);
      if (!!tmp) data = [...data, it];
    });
    return data;
  }, [selectedDonThuocs, dataSource]);
  const handleSaveGoiThuoc = async () => {
    if (selectedDTSave.length > 0) {
      gTRef.current?.setData([...selectedDTSave]);
      gTRef.current?.openModal();
    } else {
      Notification("info", "Hãy chọn thuốc để lưu!");
    }
  };
  const columns = columnsTableMenu.map(col => {
    if (col.dataIndex === "idThuoc") {
      return {
        ...col,
        options: [
          ...thuocs.map(it => ({
            value: it.id,
            label: it.id,
          })),
        ],
      };
    } else if (col.dataIndex === "tenThuoc") {
      return {
        ...col,
        options: [
          ...thuocs.map(it => ({
            value: it.name,
            label: it.name || "",
          })),
        ],
      };
    } else if (col.dataIndex === "donVi") {
      return {
        ...col,
        options: [
          ...unitMedicine.map(unit => {
            return {
              value: unit.name,
              label: unit.name,
            };
          }),
        ],
      };
    } else if (col.dataIndex === "cachDung") {
      return {
        ...col,
        options: [
          ...usageMedicine.map(usage => {
            return {
              value: usage.id,
              label: usage.name,
            };
          }),
          {
            label: "Chọn cách dùng",
            value: -1,
          },
        ],
      };
    } else if (col.dataIndex === "lieuDung") {
      return {
        ...col,
        options: optionsLieuDung,
      };
    } else if (col.dataIndex === "thanhTien") {
      return {
        ...col,
        render: (_, record) => {
          return <>{record.donGia * record.soLuong}</>;
        },
      };
    } else return col;
  });
  const getListElse = pivot => {
    let tmp = [1, 2, 3, 4].filter(it => it > pivot);
    let res = tmp.map(et => ({
      key: et,
      maThuoc: null,
      tenThuoc: null,
      donVi: null,
      donGiaBan: null,
      soLuong: null,
      // cachDung: '',
      lieuDung: null,
      nongDong: null,
      hoatChat: null,
    }));
    return res;
  };
  const [count, setCount] = useState(1);
  useEffect(() => {
    if (donThuoc && donThuocPhu) {
      if (
        donThuoc.thuocs.length + donThuocPhu.thuocs.length < 4 &&
        donThuoc.thuocs.length + donThuocPhu.thuocs.length > 0
      ) {
        let data = [
          ...donThuoc.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
          ...donThuocPhu.thuocs.map((it, index) => ({
            key: index + 1 + donThuoc.thuocs.length,
            ...it,
          })),
          ...getListElse(donThuoc.thuocs.length + donThuocPhu.thuocs.length),
        ];
        setDataSource(data);
        setDataSourceOrigin(data);
        setCount(5);
      } else if (donThuoc.thuocs.length + donThuocPhu.thuocs.length === 0) {
        setCount(5);
        setDataSource(
          [1, 2, 3, 4].map(it => ({
            key: it,
            maThuoc: null,
            tenThuoc: null,
            donVi: null,
            donGiaBan: null,
            soLuong: null,
            // cachDung: '',
            lieuDung: null,
            nongDong: null,
            hoatChat: null,
            soLuongTon: null,
          }))
        );
        setDataSourceOrigin(
          [1, 2, 3, 4].map(it => ({
            key: it,
            maThuoc: null,
            tenThuoc: null,
            donVi: null,
            donGiaBan: null,
            soLuong: null,
            // cachDung: '',
            lieuDung: null,
            nongDong: null,
            hoatChat: null,
            soLuongTon: null,
          }))
        );
      } else {
        setDataSource(
          [
            ...donThuoc.thuocs.map((it, index) => ({
              key: index + 1,
              ...it,
            })),
            ...donThuocPhu.thuocs.map((it, index) => ({
              key: index + 1 + donThuoc.thuocs.length,
              ...it,
            })),
          ].sort((a, b) => a?.thuTu - b?.thuTu)
        );
        setDataSourceOrigin(
          [
            ...donThuoc.thuocs.map((it, index) => ({
              key: index + 1,
              ...it,
            })),
            ...donThuocPhu.thuocs.map((it, index) => ({
              key: index + 1 + donThuoc.thuocs.length,
              ...it,
            })),
          ].sort((a, b) => a?.thuTu - b?.thuTu)
        );
        setCount(donThuoc.thuocs.length + donThuocPhu.thuocs.length + 1);
      }
    } else if (donThuoc && !donThuocPhu) {
      if (donThuoc.thuocs.length < 4 && donThuoc.thuocs.length > 0) {
        let data = [
          ...donThuoc.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
          ...getListElse(donThuoc.thuocs.length),
        ];
        setDataSource(data);
        setDataSourceOrigin(data);
        setCount(5);
      } else if (donThuoc.thuocs.length === 0) {
        setCount(5);
        setDataSource(
          [1, 2, 3, 4].map(it => ({
            key: it,
            maThuoc: null,
            tenThuoc: null,
            donVi: null,
            donGiaBan: null,
            soLuong: null,
            soLuongTon: null,
            // cachDung: '',
            lieuDung: null,
            nongDong: null,
            hoatChat: null,
          }))
        );
        setDataSourceOrigin(
          [1, 2, 3, 4].map(it => ({
            key: it,
            maThuoc: null,
            tenThuoc: null,
            donVi: null,
            donGiaBan: null,
            soLuong: null,
            soLuongTon: null,
            // cachDung: '',
            lieuDung: null,
            nongDong: null,
            hoatChat: null,
          }))
        );
      } else {
        setDataSource([
          ...donThuoc.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
        ]);
        setDataSourceOrigin([
          ...donThuoc.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
        ]);
        setCount(donThuoc.thuocs.length + 1);
      }
    } else if (donThuocPhu && !donThuoc) {
      if (donThuocPhu.thuocs.length < 4 && donThuocPhu.thuocs.length > 0) {
        let data = [
          ...donThuocPhu.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
          ...getListElse(donThuocPhu.thuocs.length),
        ];
        setDataSource(data);
        setDataSourceOrigin(data);
        setCount(5);
      } else if (donThuocPhu.thuocs.length === 0) {
        setCount(5);
        setDataSource(
          [1, 2, 3, 4].map(it => ({
            key: it,
            maThuoc: null,
            tenThuoc: null,
            donVi: null,
            donGiaBan: null,
            soLuong: null,
            soLuongTon: null,
            // cachDung: '',
            lieuDung: null,
            nongDong: null,
            hoatChat: null,
          }))
        );
        setDataSourceOrigin(
          [1, 2, 3, 4].map(it => ({
            key: it,
            maThuoc: null,
            tenThuoc: null,
            donVi: null,
            donGiaBan: null,
            soLuong: null,
            soLuongTon: null,
            // cachDung: '',
            lieuDung: null,
            nongDong: null,
            hoatChat: null,
          }))
        );
      } else {
        setDataSource([
          ...donThuocPhu.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
        ]);
        setDataSourceOrigin([
          ...donThuocPhu.thuocs.map((it, index) => ({
            key: index + 1,
            ...it,
          })),
        ]);
        setCount(donThuocPhu.thuocs.length + 1);
      }
    } else {
      setCount(5);
      setDataSource(
        [1, 2, 3, 4].map(it => ({
          key: it,
          maThuoc: null,
          tenThuoc: null,
          donVi: null,
          donGiaBan: null,
          soLuong: null,
          soLuongTon: null,
          // cachDung: '',
          lieuDung: null,
          nongDong: null,
          hoatChat: null,
        }))
      );
      setDataSourceOrigin(
        [1, 2, 3, 4].map(it => ({
          key: it,
          maThuoc: null,
          tenThuoc: null,
          donVi: null,
          donGiaBan: null,
          soLuong: null,
          soLuongTon: null,
          // cachDung: '',
          lieuDung: null,
          nongDong: null,
          hoatChat: null,
        }))
      );
    }
  }, [donThuoc, donThuocPhu]);
  useEffect(() => {
    if (ebcClick.actionType === EXAM_BTN_CLICK_TYPE.RELOAD_LIST_GT) {
      fetchListGoiThuoc({page: 1, limit: 20});
    }
  }, [ebcClick]);
  const activeExamTab = useAppSelector(
    state => state.examination.activeExamTab
  );
  useEffect(() => {
    if (activeExamTab == tabKeys.EXAMINATION_INFO_DETAIL.CONCLUDE_PRESCRIPT) {
      fetchDonThuocByIdPKNT();
      fetchDonThuocPhuByIdPKNT();
    }
  }, [activeExamTab]);
  useEffect(() => {
    setSelectedDonThuocs([]);
    setSelectedRowKeys([]);
    fetchDonThuocByIdPKNT();
    fetchDonThuocPhuByIdPKNT();
    if (idPKNT !== currentIdPKNT) {
      setDataSource(
        [1, 2, 3, 4].map(it => ({
          key: it,
          maThuoc: null,
          tenThuoc: null,
          donVi: null,
          donGiaBan: null,
          soLuong: null,
          soLuongTon: null,
          // cachDung: '',
          lieuDung: null,
          nongDong: null,
          hoatChat: null,
        }))
      );
      setDataSourceOrigin(
        [1, 2, 3, 4].map(it => ({
          key: it,
          maThuoc: null,
          tenThuoc: null,
          donVi: null,
          donGiaBan: null,
          soLuong: null,
          soLuongTon: null,
          // cachDung: '',
          lieuDung: null,
          nongDong: null,
          hoatChat: null,
        }))
      );
    }
  }, [idPKNT]);

  const activeTab = useAppSelector(e => e.common.activeTab);
  useEffect(() => {
    if (activeTab === tabKeys.EXAMINATION.INFOR_DETAIL) {
      if (idPKNT !== currentIdPKNT) {
        setSelectedRowKeysDrugPaket([]);
      }
    }
  }, [activeTab]);

  return (
    <div className="prescription-table-container">
      <Space direction="vertical" className="prescription-space">
        <Row justify={"space-between"} align={"middle"} style={{width: "100%"}}>
          <Col>
            <Typography className="prescription-table-title">
              Đơn thuốc
            </Typography>
          </Col>
          <Col>
            <Space>
              {/* <Button
                type="primary"
                onClick={() => {
                  getDonThuocCu(idPKNT);
                }}
              >
                Lấy đơn thuốc cũ
              </Button> */}
              <Button
                type="primary"
                onClick={() => {
                  historyModalRef.current.openModal();
                }}
              >
                Lịch sử thuốc
              </Button>
            </Space>
          </Col>
        </Row>

        <Row gutter={[8, 8]}>
          <Col xs={24} md={24} sm={24} lg={24} xl={24}>
            <TableInputAdd
              column={columns}
              data={dataSource}
              setData={setDataSource}
              pagination={false}
              rowSelection={{
                type: "checkbox",
                onChange: onSelectRow,
                selectedRowKeys: selectedRowKeys,
              }}
              thuocs={thuocs}
              count={count}
              setCount={setCount}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row gutter={[0, 8]}>
              <Row justify={"end"}>
                <SaveNewGoiThuoc ref={gTRef} />
                <Button
                  ghost
                  className="btn-sub"
                  icon={<Icons.save />}
                  onClick={handleSaveGoiThuoc}
                >
                  Lưu gói thuốc
                </Button>
              </Row>
              <Row>
                <Table
                  // rowKey={(record) => record.id}
                  columns={goiThuocColumns as any}
                  dataSource={goiThuocs}
                  bordered
                  rowSelection={{
                    type: "radio",
                    onChange: onSelectRowDrug,
                    selectedRowKeys: selectedRowKeysDrugPacket,
                    // ...rowSelection,
                  }}
                  // pagination={{
                  //   position: ["bottomRight"],
                  //   showSizeChanger: true
                  // }}
                />
              </Row>
            </Row>
          </Col>
        </Row>
        <ModalCustom title="Lịch sử đơn thuốc" ref={historyModalRef}>
          <PrescriptionHistoryModal
            idPhieuKham={idPKNT}
            setDonThuocLichSu={setDonThuocLichSu}
          ></PrescriptionHistoryModal>
        </ModalCustom>
      </Space>
    </div>
  );
});

export default PrescriptionTable;
